declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

const COOKIEYES_ID = "cfa784a3510babf0db771a26";

/** Catégories CookieYes acceptées par le visiteur. */
export interface Consent {
  advertisement: boolean;
  analytics: boolean;
  functional: boolean;
}

interface CookieYesEvent extends Event {
  detail?: { accepted?: string[] };
}

/** Bannière CookieYes du site vitrine, même compte pour que le choix fait sur qalimo.fr s'applique ici. */
export function loadCookieYes() {
  if (document.getElementById("cookieyes")) return;
  const script = document.createElement("script");
  script.id = "cookieyes";
  script.src = `https://cdn-cookieyes.com/client_data/${COOKIEYES_ID}/script.js`;
  document.head.appendChild(script);
}

/** Choix déjà enregistré dans le cookie `cookieyes-consent`, `null` tant que le visiteur n'a pas répondu. */
function readStoredConsent(): Consent | null {
  const match = document.cookie.match(/(?:^|; )cookieyes-consent=([^;]*)/);
  if (!match) return null;
  const values: Record<string, boolean> = {};
  for (const pair of decodeURIComponent(match[1]).split(",")) {
    const [key, value] = pair.split(":");
    values[key] = value === "yes";
  }
  if (!values.action) return null;
  return {
    advertisement: !!values.advertisement,
    analytics: !!values.analytics,
    functional: !!values.functional,
  };
}

/**
 * Consentement publicitaire déjà donné dans la bannière CookieYes, `null` tant que le visiteur
 * n'a pas répondu. Transmis à l'inscription pour conditionner l'envoi serveur des conversions.
 */
export function storedAdvertisingConsent(): boolean | null {
  return readStoredConsent()?.advertisement ?? null;
}

function updateGoogleConsent(consent: Consent) {
  const ads = consent.advertisement ? "granted" : "denied";
  window.gtag?.("consent", "update", {
    ad_storage: ads,
    ad_user_data: ads,
    ad_personalization: ads,
    analytics_storage: consent.analytics ? "granted" : "denied",
    functionality_storage: consent.functional ? "granted" : "denied",
    personalization_storage: consent.functional ? "granted" : "denied",
  });
}

/**
 * Applique le choix du visiteur au Consent Mode Google (le défaut « denied » est posé dans
 * `index.html` avant tout chargement) et le transmet à `onChange`, au chargement si un
 * choix existe déjà puis à chaque réponse à la bannière.
 */
export function initConsent(onChange: (consent: Consent) => void) {
  const apply = (consent: Consent) => {
    updateGoogleConsent(consent);
    onChange(consent);
  };
  const stored = readStoredConsent();
  if (stored) apply(stored);
  document.addEventListener(
    "cookieyes_consent_update",
    (event: CookieYesEvent) => {
      const accepted = event.detail?.accepted ?? [];
      apply({
        advertisement: accepted.includes("advertisement"),
        analytics: accepted.includes("analytics"),
        functional: accepted.includes("functional"),
      });
    },
  );
}
